module.exports = __webpack_public_path__ + "static/media/setting-focused.c3d3f6c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/setting-focused.svg
// module id = 1221
// module chunks = 0